import React from "react";
import profile_pic from "./Figures/doctor/doc2.png";

const credentials = [
  "Physician M.Sc, Σόφια 1997",
  "Παιδιατρική ειδικότητα, ΠΠΓΝΛ",
  "Παιδιατρική Διατροφή, Boston University",
  "Early Nutrition, LMU Munich",
  "Ι.Σ. Μαγνησίας, μέλος από 1999",
];

const AboutDoctor = () => {
  return (
    <section className="bg-white text-gray-600">
      <div className="container mx-auto lg:px-28 px-6 py-16 md:py-20">
        <div className="flex md:flex-row flex-col gap-12 items-start">

          {/* Left: sticky photo + name + credential pills */}
          <div className="md:w-[35%] flex-shrink-0 md:sticky md:top-24">
            <img
              className="rounded-2xl shadow-lg w-full object-cover"
              alt="Δρ. Βασιλική Μαργαριτοπούλου"
              src={profile_pic}
            />
            <div className="mt-5">
              <p className="text-xl font-semibold text-gray-900 leading-snug">
                Βασιλική Μαργαριτοπούλου
              </p>
              <p className="text-sky-600 font-medium text-sm mt-1">Παιδίατρος — Βόλος</p>
              <div className="flex flex-wrap gap-2 mt-4">
                {credentials.map((c) => (
                  <span
                    key={c}
                    className="px-3 py-1 bg-sky-50 text-sky-700 rounded-full text-xs font-medium border border-sky-100"
                  >
                    {c}
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* Right: bio text */}
          <div className="md:w-[65%] text-left">
            <h1 className="animate-fade-up sm:text-3xl text-2xl mb-6 font-semibold text-gray-900 tracking-tight">
              Η Παιδίατρος
            </h1>
            <div className="leading-relaxed space-y-4 text-gray-600">
              <p>
                Λίγα λόγια για μένα … Αποφοίτησα το 1997 από την Ιατρική Σχολή του Πανεπιστημίου
                της Σόφιας (Medical University of Sofia), με τον ακαδημαϊκό τίτλο <b>Physician M.Sc</b> και
                βαθμό πτυχίου <b>ΑΡΙΣΤΑ</b> (9,66).
              </p>
              <p>
                Υπηρέτησα τη θητεία υπαίθρου ως αγροτική ιατρός στο Π.Ι Καναλίων – Κ.Υ. Βελεστίνου.
              </p>
              <p>
                Στη συνέχεια ειδικεύτηκα (από το 2000 έως το 2005), ως παιδίατρος στην Π/Δ κλινική
                του Π.Π.ΓΝΛ. όπου και έλαβα τον τίτλο της ειδικότητας της <b>Παιδιατρικής</b> (μετά από
                ειδίκευση στην Παιδιατρική και 6μηνη εκπαίδευση στην Νεογνολογία).
              </p>
              <p>
                Από το 2001 εργάστηκα στο Εργαστήριο Μελέτης Ύπνου του Πανεπιστημίου Θεσσαλίας,
                μελετώντας παιδιά με προβλήματα διαταραχών ύπνου, αποφρακτικής υπνικής άπνοιας και
                ροχαλητό, στα πλαίσια της Παιδιατρικής ειδικότητας που ολοκληρώθηκε το 2004.
              </p>
              <p>
                Συμμετείχα σε πολλά συνέδρια, τόσο στην Ελλάδα όσο και στο εξωτερικό, κατά τη
                διάρκεια της ειδίκευσής μου και κατά την πολύχρονη άσκηση του παιδιατρικού
                επαγγέλματος, στο πλαίσιο της συνεχιζόμενης επιστημονικής μου κατάρτισης.
              </p>
              <p>
                Συμμετείχα σε αρκετές δημοσιεύσεις σε συνέδρια τόσο της Ελλάδας όσο και του εξωτερικού.
              </p>
              <p>
                Πιστοποιημένη επάρκεια <b>Παίς</b> (πρότυπη διαδικασία ανίχνευσης διαταραχών
                επικοινωνίας αυτιστικού φάσματος).
              </p>
              <p>
                Μεταπτυχιακό πανεπιστημίου Βοστώνης στην <b>Παιδιατρική Διατροφή</b>.
              </p>
              <p>
                Μεταπτυχιακό πανεπιστημίου LMU Munchen Prof. Koletsko, in <b>Early Nutricion</b>.
              </p>
              <p>
                Από το 1995 έως το 1997 συμμετείχα στη σχολή Διατροφολογίας της Ιατρικής Σχολής
                του Πανεπιστημίου της Σόφιας, όπου ειδικεύτηκα στη <b>Διατροφολογία</b>, <b>Τεχνολογία
                Τροφών</b> και <b>'Ελεγχο της Υγιεινής Διατροφής και των Τροφών</b>, <b>Βιολογία και
                Χημικοί Μικροοργανισμοί Τροφίμων</b> καθώς και στην <b>Διαιτητική και στις Παθήσεις
                σχετικές με μη Ορθολογική Διατροφή</b>.
              </p>
              <p>Είμαι μέλος του Ιατρικού Συλλόγου Μαγνησίας από το 1999.</p>
              <p>Γνωρίζω Αγγλικά, Γερμανικά, Ιταλικά, Ολλανδικά και Βουλγαρικά.</p>
              <p>Είμαι παντρεμένη και έχω δύο γιους 16 και 20 ετών.</p>
              <p>
                Από το 2006 δραστηριοποιούμαι στο χώρο της ιδιωτικής παροχής υπηρεσιών υγείας
                στο Βόλο στην οδό Όγλ 12, όπου έχω το ιατρείο μου.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default AboutDoctor;
